import { ShaderMaterial, Uniform, Vector2 } from 'three';
import standardVertexShader from 'shared/renderingEngine/shaders/StandardVertexShader.glsl';
import gradientShader from 'shared/renderingEngine/shaders/GradientShader.glsl';
import { resolvePaletteVector4 } from '../../utils/colors';
import { PLANOGRAM_CONFIG } from '../../config/PlanogramConfig';
export default class GradientMaterial extends ShaderMaterial {
    constructor(pointCount) {
        const uniforms = {
            pointPositions: new Uniform([]),
            pointColors: new Uniform([]),
            planogramUV: new Uniform([]),
            blendPower: new Uniform(1.0),
        };
        const defines = {
            POINT_COUNT: pointCount.toString(),
            TORUS_WIDTH: PLANOGRAM_CONFIG.width.toFixed(1),
        };
        super({
            vertexShader: standardVertexShader,
            fragmentShader: gradientShader,
            defines,
            uniforms,
            transparent: true,
        });
    }
    update(gradient, planogramMatrix, palette) {
        this.uniforms.pointColors.value = gradient.points.map(it => resolvePaletteVector4(it.color, it.opacity, palette));
        this.uniforms.pointPositions.value = gradient.points.map(it => new Vector2(it.x, it.y));
        this.uniforms.planogramUV.value = planogramMatrix;
        this.uniforms.blendPower.value = gradient.blendPower;
    }
}
